export default "__VITE_ASSET__PvcAhUoN__"